<template>
  <div class="page-footer-container">
    <div class="page-footer-body">
      <div class="page-footer-left">
        <div class="logo">
          <img src="@/assets/images/ls-logo-white.png" alt="" />
        </div>
        <div class="company-name-container">
          <span>{{ companyData.name }}</span>
          <span class="english">{{ companyData.english }}</span>
        </div>
      </div>
      <div class="page-footer-center">
        <ul class="nav">
          便捷导航
          <li @click="linkTo('/')">首页</li>
          <li @click="linkTo('/product/zn')">产品中心</li>
          <li @click="linkTo('/solution')">解决方案</li>
          <li @click="toPartner">合作伙伴</li>
          <li @click="linkTo('/aboutUs')">关于栗鼠</li>
        </ul>
      </div>
      <div class="page-footer-right">
        <div class="contact-information">
          <div class="title">
            <span>联系方式</span>
          </div>
          <div class="contact-container" style="margin-top: 20px">
            <span class="label">电话：</span>
            <span class="value">{{ companyData.phone }}</span>
          </div>
          <div class="contact-container">
            <span class="label">地址：</span>
            <span class="value">{{ companyData.location }}</span>
          </div>
          <div class="qr-code-container">
            <!-- <img src="" alt=""> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="page-footer-footer">
      <span>友情链接：</span>
      <div class="link">
        <span>杭州玛莉亚妇产医院</span>
      </div>
      <div class="link">
        <span>杭州辰戈科技有限公司</span>
      </div>
    </div> -->
    <contact-btn></contact-btn>
  </div>
</template>

<script>
import contactBtn from "../components/contactBtn";
export default {
  components: {
    contactBtn,
  },
  data() {
    return {};
  },
  methods: {
    linkTo(path) {
      this.$router.push(path);
    },
    toPartner() {
      if (this.$route.name == "home") {
      } else {
        this.$router.push({
          path: "/",
          query: {
            to: "partner",
          },
        });
      }
      this.$emit("toPartner");
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer-container {
  position: relative;
  width: 100%;
  min-height: 400px;
  background: #0a1732;
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  .page-footer-body {
    display: flex;
    border-bottom: 1px solid #20335b;
    padding-bottom: 55px;
    .page-footer-left {
      flex: 6;
      margin-top: 60px;
      .logo {
        img {
          height: 30px;
        }
      }
      .company-name-container {
        margin-top: 60px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #ffffff;
        .english {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #626e88;
        }
        span {
          display: block;
        }
      }
    }
    .page-footer-center {
      flex: 3;
      margin-top: 60px;
      .nav {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #ffffff;
        li {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #858fa3;
          cursor: pointer;
          user-select: none;
          &:not(:first-child) {
            margin-top: 16px;
          }
          &:first-child {
            margin-top: 20px;
          }
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
    .page-footer-right {
      flex: 2;
      margin-top: 60px;
      .contact-information {
        .title {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #ffffff;
        }
        .contact-container {
          width: 200px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #858fa3;
          margin-top: 16px;
        }
        .qr-code-container {
          margin-top: 16px;
          width: 70px;
          height: 70px;
          background: #ffffff;
        }
      }
    }
  }
  .page-footer-footer {
    flex: 1;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #858fa3;
    display: flex;
    align-items: center;
    .link {
      margin-right: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      user-select: none;
      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/common/pageFooter.vue